import {
    URLAPI,
    TURN_PATH,
    TURN_CREATE_PATH,
    TURN_UPDATE_PATH,
    TURN_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_turn: {
        data: [],

        status: 0,
        message: {},
    },

    _create_turn: {
        data: {},
        status: 0,
        message: {},
    },
    _update_turn: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_turn: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_TURN = "GET_ALL_TURN";
export const CREATE_TURN = "CREATE_TURN";
export const UPDATE_TURN = "UPDATE_TURN";
export const DELETE_TURN = "DELETE_TURN";

export const turn_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_TURN:
            return {
                ...state,
                _get_all_turn: action.payload,
            };
        case CREATE_TURN:
            return {
                ...state,
                _create_turn: action.payload,
            };
        case UPDATE_TURN:
            return {
                ...state,
                _update_turn: action.payload,
            };
        case DELETE_TURN:
            return {
                ...state,
                _delete_turn: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllTurn = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${TURN_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_TURN,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_TURN,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_TURN,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

//create turn
export const createTurn = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${TURN_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_TURN,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_TURN,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_TURN,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateTurn = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${TURN_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_TURN,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_TURN,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_TURN,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteTurn = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${TURN_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_TURN,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_TURN,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_TURN,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_turn = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
